const Rating = function (data) {
  if (!data) data = {};
  this.OverallRating = data.OverallRating || null;
  this.RatingCount = data.RatingCount || null;
};
export default Rating;
